import { render, staticRenderFns } from "./BeaconDemo.vue?vue&type=template&id=318b5964&scoped=true"
import script from "./BeaconDemo.vue?vue&type=script&lang=js"
export * from "./BeaconDemo.vue?vue&type=script&lang=js"
import style0 from "./BeaconDemo.vue?vue&type=style&index=0&id=318b5964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318b5964",
  null
  
)

export default component.exports